






































// import { Component, Mixins } from 'vue-mixin-decorator';
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class LogItem extends Vue {
  @Prop() private item!:any;
  public expand = false;
}
